import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SettingItemViewComponent } from './setting-item-view.component';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [SettingItemViewComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    TranslateModule
  ],
  exports: [
    SettingItemViewComponent
  ]
})
export class SettingItemViewModule { }
